var _g, _g2, _defs;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAmount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: -0.173998,
    y: -2.05388,
    width: 19.5833,
    height: 19.5843
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      clipPath: "url(#bgblur_0_18165_3568_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_18165_3568)",
    "data-figma-bg-blur-radius": 4.19646
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9.61777,
    cy: 7.73788,
    r: 5.59531,
    fill: "url(#paint0_linear_18165_3568)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.61777,
    cy: 7.73788,
    r: 5.59531,
    fill: "url(#paint1_linear_18165_3568)"
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    x: -3.45025,
    y: -2.11724,
    width: 19.4112,
    height: 19.4103
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      clipPath: "url(#bgblur_1_18165_3568_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_18165_3568)",
    "data-figma-bg-blur-radius": 4.11724
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.2553 2C3.17089 2 0.666992 4.5039 0.666992 7.58831C0.666992 10.6727 3.17089 13.1766 6.2553 13.1766C9.33972 13.1766 11.8436 10.6727 11.8436 7.58831C11.8366 4.5039 9.33972 2 6.2553 2ZM5.59786 6.80497L7.28344 7.39248C7.89193 7.6093 8.18569 8.03594 8.18569 8.69339C8.18569 9.44875 7.58419 10.0712 6.84981 10.0712H6.82183C6.80252 10.0712 6.78686 10.0869 6.78686 10.1062C6.78686 10.393 6.54906 10.6308 6.2623 10.6308C5.97554 10.6308 5.73774 10.393 5.73774 10.1062C5.73774 10.0827 5.71917 10.0635 5.69576 10.0617C4.93907 10.0057 4.33891 9.36413 4.33891 8.56749C4.33891 8.28073 4.57671 8.04293 4.86347 8.04293C5.15023 8.04293 5.38803 8.28073 5.38803 8.56749C5.38803 8.81928 5.56988 9.02211 5.79369 9.02211H6.84281C7.00368 9.02211 7.12957 8.87523 7.12957 8.69339C7.12957 8.44859 7.08761 8.4346 6.92674 8.37865L5.24116 7.79114C4.63966 7.58132 4.33891 7.15468 4.33891 6.49023C4.33891 5.73487 4.94041 5.11239 5.67479 5.11239H5.70976C5.72521 5.11239 5.73774 5.09986 5.73774 5.08441C5.73774 4.79765 5.97554 4.55985 6.2623 4.55985C6.54906 4.55985 6.78686 4.79765 6.78686 5.08441C6.78686 5.10789 6.80542 5.12714 6.82884 5.12888C7.58553 5.18493 8.18569 5.82648 8.18569 6.62312C8.18569 6.90988 7.94789 7.14768 7.66113 7.14768C7.37437 7.14768 7.13657 6.90988 7.13657 6.62312C7.13657 6.37133 6.95472 6.1685 6.73091 6.1685H5.68179C5.52092 6.1685 5.39503 6.31538 5.39503 6.49723C5.38803 6.73503 5.43 6.74902 5.59786 6.80497Z",
    fill: "url(#paint2_linear_18165_3568)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.25488 2.11426C9.18137 2.11426 11.5689 4.41579 11.7217 7.30664L11.7295 7.58887C11.7292 10.6099 9.27595 13.0625 6.25488 13.0625C3.23383 13.0623 0.78125 10.609 0.78125 7.58789C0.781478 4.56698 3.23397 2.11449 6.25488 2.11426ZM6.2627 4.44531C5.94149 4.44531 5.67396 4.68938 5.63184 5C4.85076 5.02371 4.22461 5.68981 4.22461 6.49023C4.22461 6.83978 4.30389 7.13741 4.4707 7.37695C4.63765 7.61654 4.88509 7.78843 5.20312 7.89941L6.88867 8.48633H6.88965C6.93168 8.50095 6.9567 8.51033 6.97559 8.51953C6.99203 8.52758 6.9962 8.53203 6.99707 8.5332C7.00211 8.53996 7.01562 8.56713 7.01562 8.69336C7.01562 8.82783 6.92577 8.9082 6.84277 8.9082H5.79395C5.64505 8.9082 5.50195 8.76844 5.50195 8.56738C5.50189 8.21751 5.21317 7.92871 4.86328 7.92871C4.51348 7.92882 4.22467 8.21757 4.22461 8.56738C4.22461 9.40196 4.83915 10.0795 5.62891 10.168C5.66061 10.4894 5.93368 10.7451 6.2627 10.7451C6.58644 10.7449 6.854 10.4969 6.89258 10.1826C7.67373 10.159 8.2998 9.49383 8.2998 8.69336C8.2998 8.34756 8.2225 8.05208 8.05664 7.8125C7.89069 7.57286 7.6434 7.39968 7.32227 7.28516L7.32129 7.28418L5.63574 6.69727L5.63379 6.69629C5.58977 6.68162 5.56292 6.67247 5.54297 6.66309C5.52571 6.65496 5.52183 6.65087 5.52148 6.65039C5.51855 6.64654 5.50618 6.62391 5.50977 6.50098V6.49707C5.50984 6.36278 5.59872 6.2833 5.68164 6.2832H6.73047C6.87934 6.2832 7.02243 6.42203 7.02246 6.62305C7.02246 6.97297 7.31121 7.26172 7.66113 7.26172C8.01105 7.26171 8.2998 6.97297 8.2998 6.62305C8.29977 5.78806 7.68488 5.10941 6.89453 5.02148C6.86224 4.7008 6.5911 4.44552 6.2627 4.44531Z",
    stroke: "url(#paint3_linear_18165_3568)",
    strokeWidth: 0.228736
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_18165_3568",
    x: -0.173998,
    y: -2.05388,
    width: 19.5833,
    height: 19.5843,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.582841,
    dy: 0.582841
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.291421
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_18165_3568"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_18165_3568_clip_path",
    transform: "translate(0.173998 2.05388)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9.61777,
    cy: 7.73788,
    r: 5.59531
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_18165_3568",
    x: -3.45025,
    y: -2.11724,
    width: 19.4112,
    height: 19.4103,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.57184,
    dy: 0.57184
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.28592
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_18165_3568"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_1_18165_3568_clip_path",
    transform: "translate(3.45025 2.11724)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.2553 2C3.17089 2 0.666992 4.5039 0.666992 7.58831C0.666992 10.6727 3.17089 13.1766 6.2553 13.1766C9.33972 13.1766 11.8436 10.6727 11.8436 7.58831C11.8366 4.5039 9.33972 2 6.2553 2ZM5.59786 6.80497L7.28344 7.39248C7.89193 7.6093 8.18569 8.03594 8.18569 8.69339C8.18569 9.44875 7.58419 10.0712 6.84981 10.0712H6.82183C6.80252 10.0712 6.78686 10.0869 6.78686 10.1062C6.78686 10.393 6.54906 10.6308 6.2623 10.6308C5.97554 10.6308 5.73774 10.393 5.73774 10.1062C5.73774 10.0827 5.71917 10.0635 5.69576 10.0617C4.93907 10.0057 4.33891 9.36413 4.33891 8.56749C4.33891 8.28073 4.57671 8.04293 4.86347 8.04293C5.15023 8.04293 5.38803 8.28073 5.38803 8.56749C5.38803 8.81928 5.56988 9.02211 5.79369 9.02211H6.84281C7.00368 9.02211 7.12957 8.87523 7.12957 8.69339C7.12957 8.44859 7.08761 8.4346 6.92674 8.37865L5.24116 7.79114C4.63966 7.58132 4.33891 7.15468 4.33891 6.49023C4.33891 5.73487 4.94041 5.11239 5.67479 5.11239H5.70976C5.72521 5.11239 5.73774 5.09986 5.73774 5.08441C5.73774 4.79765 5.97554 4.55985 6.2623 4.55985C6.54906 4.55985 6.78686 4.79765 6.78686 5.08441C6.78686 5.10789 6.80542 5.12714 6.82884 5.12888C7.58553 5.18493 8.18569 5.82648 8.18569 6.62312C8.18569 6.90988 7.94789 7.14768 7.66113 7.14768C7.37437 7.14768 7.13657 6.90988 7.13657 6.62312C7.13657 6.37133 6.95472 6.1685 6.73091 6.1685H5.68179C5.52092 6.1685 5.39503 6.31538 5.39503 6.49723C5.38803 6.73503 5.43 6.74902 5.59786 6.80497Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_18165_3568",
    x1: 9.61777,
    y1: 2.14258,
    x2: 0.309761,
    y2: 12.6226,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDFF6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A2B329"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_18165_3568",
    x1: 9.61777,
    y1: 2.14258,
    x2: 12.4669,
    y2: 14.6215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0063F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0051C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_18165_3568",
    x1: 6.2553,
    y1: 2,
    x2: -3.04107,
    y2: 12.4669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDFF6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A2B329"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_18165_3568",
    x1: 19.8679,
    y1: 17.4414,
    x2: 5.08853,
    y2: 14.1136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmount);
export default __webpack_public_path__ + "static/media/amount.dd5c5049031cbea8475b459c731cce77.svg";
export { ForwardRef as ReactComponent };